import { useSelector } from 'react-redux';
import { getChosenBusinessEntitlement } from 'store/authentication/selectors';

interface KiCodeAccessState {
  authentication?: {
    access?: {
      sections?: {
        settings_section?: {
          ai_business_generation?: { edit?: boolean | null } | null;
        } | null;
      } | null;
    } | null;
  } | null;
}

const selectKiCodeAccess = (state: KiCodeAccessState): boolean =>
  state.authentication?.access?.sections?.settings_section
    ?.ai_business_generation?.edit === true &&
  getChosenBusinessEntitlement(state, 'kicode_preview') === true;

/**
 * KiCode requires the AI Business Builder create/edit permission and the
 * business's `kicode_preview` entitlement, both strictly `true`; a missing
 * entitlement counts as false. The pre-release ("Preview") permission is
 * intentionally not involved.
 */
export const useKiCodeAccess = (): boolean => useSelector(selectKiCodeAccess);
